import { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Tab, Tabs, TextField, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import { getClientBranches, getClientsOverview } from '../../../actions/admin/clients';
import { currentYearRange } from '../../../helpers/admin/clients/clientHelper';
import CustomerDirectory from './CustomerDirectory';
import CustomerOverview from './CustomerOverview';
import { GeographyInsights, ProductInsights, SeasonalityInsights } from './CustomerInsights';

const Clients = () => {
    const [tab, setTab] = useState(0);
    const [draftRange, setDraftRange] = useState(currentYearRange);
    const [filters, setFilters] = useState(currentYearRange);
    const [overview, setOverview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [branches, setBranches] = useState([]);

    useEffect(() => {
        getClientBranches().then(result => result.status && setBranches(result.branches));
    }, []);
    useEffect(() => {
        let active = true;
        setLoading(true);
        getClientsOverview(filters).then(result => {
            if (active) { setOverview(result.status ? result : null); setLoading(false); }
        });
        return () => { active = false; };
    }, [filters]);

    return <Container maxWidth="xl" sx={{ mb: 6 }}>
        <Box sx={{ mb: 3 }}><Typography variant="h4" fontWeight={700}>Clientes</Typography><Typography color="text.secondary">Inteligencia omnicanal y expediente 360° de clientes Nefrópolis.</Typography></Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, overflowX: 'auto' }}><Tabs value={tab} onChange={(_, value) => setTab(value)} variant="scrollable" scrollButtons="auto">
            <Tab label="Resumen" /><Tab label="Directorio" /><Tab label="Productos" /><Tab label="Canales y ubicación" /><Tab label="Temporalidad" />
        </Tabs></Box>
        {tab !== 1 && <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }}>
            <Grid item xs={12} sm="auto"><TextField size="small" type="date" label="Desde" InputLabelProps={{ shrink: true }} value={draftRange.dateFrom} onChange={event => setDraftRange(current => ({ ...current, dateFrom: event.target.value }))} /></Grid>
            <Grid item xs={12} sm="auto"><TextField size="small" type="date" label="Hasta" InputLabelProps={{ shrink: true }} value={draftRange.dateTo} onChange={event => setDraftRange(current => ({ ...current, dateTo: event.target.value }))} /></Grid>
            <Grid item xs={12} sm="auto"><Button variant="outlined" startIcon={<RefreshIcon />} onClick={() => setFilters(draftRange)}>Aplicar periodo</Button></Grid>
        </Grid>}
        {tab === 0 && <CustomerOverview data={overview} loading={loading} />}
        {tab === 1 && <CustomerDirectory branches={branches} />}
        {tab === 2 && <ProductInsights filters={filters} />}
        {tab === 3 && <GeographyInsights filters={filters} />}
        {tab === 4 && <SeasonalityInsights filters={filters} />}
    </Container>;
};

export default Clients;
